import React, { useEffect, useState } from "react";
import GoogleModernIcon from "../../../Assets/svgs/GoogleModernIcon";
import MicrosoftIcon from "../../../Assets/svgs/MicrosoftIcon";
import { getUserLinkAccounts } from "../../../Redux/Slice/Integration/GetUserLinkAccountSlice";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../Common/Loader";
import { deleteIntegration } from "../../../Redux/Slice/Integration/DeleteIntegrationSlice";
import { capitalize } from "@mui/material";
import UnLinkIcon from "../../../Assets/svgs/UnLinkIcon";

const NativeAppsIntegration = ({ showSuccessMessage, showErrorMessage }) => {
  const { linkedAccountsData, loading } = useSelector(
    (state) => state.linkedAccounts
  );
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const unlinkIntegration = async (integration) => {
    // Handle removing the integration
    const id = integration?.account?.id;
    setIsLoading(true);
    const result = await dispatch(deleteIntegration(id));
    if (
      deleteIntegration.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      showSuccessMessage(
        `${capitalize(
          integration?.provider
        )} integration unlinked successfully!`,
        () => dispatch(getUserLinkAccounts())
      );
    } else {
      setIsLoading(false);
      showErrorMessage(
        result?.payload?.error?.message ?? result?.payload?.data?.message
      );
    }
  };

  const onClickIntegration = (integration) => {
    window.open(integration?.connectUrl, "_blank");
  };

  useEffect(() => {
    dispatch(getUserLinkAccounts());
  }, []);

  return (
    <div className="tabsContent">
      {loading || isLoading ? <Loader /> : null}
      <div className="details">
        <div className="appsWrap">
          <h1 className="title title--h3">Available apps</h1>
          <div className="appsWrap__list">
            {Array.isArray(linkedAccountsData?.data) &&
            linkedAccountsData?.data.length > 0 ? (
              linkedAccountsData?.data.map((item, index) => (
                <div className="appsWrap__list__item" key={index}>
                  <div className="appsWrap__card">
                    <div className="titleContainer">
                      <h1 className="title title--h5">
                        <span className="icon">
                          {item?.provider == "google" ? (
                            <GoogleModernIcon />
                          ) : (
                            <MicrosoftIcon />
                          )}
                        </span>
                        {item?.provider == "google"
                          ? "Google Calendar"
                          : "Microsoft Calendar"}
                      </h1>
                      {item?.isConnected ? (
                        <button onClick={() => unlinkIntegration(item)}>
                          <UnLinkIcon />
                        </button>
                      ) : null}
                    </div>
                    <p className="para">
                      {item?.provider == "google"
                        ? "Connect your Google Calendar to sync and manage calls effortlessly. Stay organized and keep track of your schedule with real-time updates."
                        : "Integrate your Microsoft Calendar to streamline event management. Easily sync your calls and stay on top of your plans with automatic updates."}
                    </p>
                    <div className="btn__group">
                      <button
                        className="btn btn__primary btn--full"
                        disabled={item?.isConnected}
                        onClick={() => onClickIntegration(item)}
                      >
                        Enable
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-data">No linked accounts available.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NativeAppsIntegration;
